import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Impulse } from "~/tools/impulse";
import { usePermanent } from "~/tools/use-permanent";

import { SmartHistoryQueue } from "./SmartHistoryQueue";
import { schema } from "./schema";

/**
 * Creates a SmartHistoryQueue.
 *
 * The queue is kept in-memory only so that each browser tab
 * maintains its own independent navigation history.
 * Enqueues the current location on every location change.
 *
 * @return an Impulse containing the SmartHistoryQueue.
 */
export const useSmartHistoryQueue = (): Impulse<SmartHistoryQueue> => {
	const location = useLocation();

	const queue = usePermanent(() => Impulse(SmartHistoryQueue.decode(schema, "", { maxSize: 100 })));

	// write to the queue on location change
	useEffect(() => {
		queue.setValue((current) => current.enqueue(location));
	}, [queue, location]);

	return queue;
};
